import { string, arrayOf } from 'prop-types';
import React from 'react';

const FabricImageContainer = ({ mainImage, images = [] }) => {
	const defaultImage = `${process.env.PUBLIC_URL}/images/trend/demo-dress.png`;
	const filledImages = [...images, ...Array(4 - images.length).fill(defaultImage)].slice(0, 4);

	return (
		<div className="trend-product-img-container">
			<div className="prev-img">
				<img src={mainImage || defaultImage} alt="" />
			</div>
			<div className="prev-img-thumb">
				{filledImages.map((img, index) => (
					<div key={index} className={`single-${['first', 'second', 'third', 'fourth'][index]}`}>
						<img src={img || defaultImage} alt={`Thumbnail ${index + 1}`} />
					</div>
				))}
			</div>
		</div>
	);
};

FabricImageContainer.propTypes = {
	mainImage: string.isRequired,
	images: arrayOf(string).isRequired
};

export default FabricImageContainer;
